import { Chrome } from "lucide-react";
import { EmailLink } from "./EmailLink";
import { storeUrl } from "../lib/links";
import { home } from "../content/home";

const { headline, body, cta, talk } = home.finalCta;

export function FinalCtaSection() {
  return (
    <section className="px-4 pb-24 pt-8 sm:px-6 lg:pb-32">
      <div className="mx-auto max-w-6xl rounded-[28px] border border-char bg-brand-600 px-6 py-16 text-center shadow-offset sm:px-12 lg:py-24">
        <h2 className="font-serif text-[clamp(2.5rem,6vw,4.75rem)] font-medium leading-[0.98] tracking-[-0.015em] text-white">
          {headline.line1}
          <br />
          <em className="text-[#bfe6fb]">{headline.line2}</em>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-sans text-lg leading-relaxed text-white">{body}</p>
        <div className="mt-10 flex flex-col items-center justify-center gap-5 sm:flex-row">
          <a
            href={storeUrl("final_cta")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-12 items-center gap-2 rounded-[12px] border border-char bg-paper px-6 font-sans text-[15px] font-semibold text-char shadow-offset transition-[transform,box-shadow] duration-150 hover:-translate-x-0.5 hover:translate-y-0.5 hover:shadow-[-3px_4px_0_0_#262524] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-600"
          >
            <Chrome className="h-4 w-4" aria-hidden="true" />
            {cta}
          </a>
          <EmailLink email="hello@intakall.io" align="center" className="rounded font-sans text-[15px] font-semibold text-white underline decoration-white/40 underline-offset-[6px] hover:decoration-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white">
            {talk}
          </EmailLink>
        </div>
      </div>
    </section>
  );
}
